import { checkSocialAuth } from './methods/check-auth'

/**
 * Auth actions for API communication
 */
export const authActions = {
  checkSocialAuth,
}

export {
  checkSocialAuth,
}
